import { Link } from "@design-system/components";
import { footerLinks } from "@design-system/data";
import { ScrollToTopButton } from "@design-system/layouts/CommonLayout/ScrollToTopButton";
import { trans } from "@mongez/localization";

export function FooterLinks() {
  return (
    <div className="col-span-8 grid grid-cols-[1fr_1fr_1fr_minmax(min-content,max-content)] items-start gap-10 py-10 max-md:hidden xl:py-[6.5rem] xl:ps-[5.375rem]">
      {footerLinks.map((item, index) => (
        <div key={index}>
          <h5 className="mb-6 text-xl font-medium">{trans(item.title)}</h5>
          <div className="flex flex-col gap-4">
            {item.children.map((link, index) => (
              <Link
                key={index}
                to={link.href as string}
                className="font-light text-white text-opacity-70 duration-300 hover:underline"
              >
                {trans(link.title)}
              </Link>
            ))}
          </div>
        </div>
      ))}
      <div className="flex items-end justify-end">
        <ScrollToTopButton />
      </div>
    </div>
  );
}
